export const hourAndMinutesPattern = /^(2[0-3]|1[0-9]|0[0-9]):([0-5][0-9]){1}$/;

export const fileNamePattern = /^[A-Za-z0-9_-]+.(png|jpg|jpeg)$/;

//alpha numeric characters with hyphen, underscore and empty space
export const hundredCharacterLimitNamePattern = /^[A-Za-z0-9-_\s]{1,100}$/;
